export default class DonationGroup {

	constructor() {
		this.id = 0;
        this.agentId = 0;
        this.donationDate = new Date();
		this.donationToId = 0;
		this.paymentMethod = 0;
		this.dueDate = null;
        this.depositDate = null;
        this.depositObservation = null;
		this.donations = [];
		this.transfers = [];
	}
}